import * as React from 'react'

function SvgAccountFilled(props, svgRef) {
  return (
    <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M8.791 10c2.775 0 5.024-2.238 5.024-5s-2.25-5-5.024-5C6.016 0 3.768 2.238 3.768 5s2.248 5 5.023 5zm3.517 1.25h-.656a6.867 6.867 0 01-5.722 0h-.655C2.363 11.25 0 13.602 0 16.5v1.625A1.88 1.88 0 001.884 20h13.815a1.88 1.88 0 001.883-1.875V16.5c0-2.898-2.362-5.25-5.274-5.25z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgAccountFilled)
export default ForwardRef
